import Axios from "axios";
import {
  SET_CASH_FLOW_REPORT,
  UNSET_CASH_FLOW_REPORT,
} from "@/store/mutation-types";
import {
  getCashFlowReport,
} from "@/store/api";

const state = {
  cashFlowReport: [],
};

const getters = {
  getCashFlowReport(state) {
    return state.cashFlowReport;
  },
};

const mutations = {
  [SET_CASH_FLOW_REPORT](state, data) {
    state.cashFlowReport = data;
  },
  [UNSET_CASH_FLOW_REPORT](state) {
    state.cashFlowReport = [];
  },
};

const actions = {
  getCashFlow({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(`${getCashFlowReport}`, { params: data })
        .then((response) => {
          commit(SET_CASH_FLOW_REPORT, response.data.data || []);
          resolve(response.data);
        })
        .catch((error) => {
          commit(UNSET_CASH_FLOW_REPORT);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING", null, { root: true });
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

